<template>
  <section class="d-flex flex-column border">
    <span>12+</span>
    <h4>of experiece</h4>
  </section>
</template>
